export function rectContains(rect, point) {
    return (point.x >= rect.x &&
        point.x <= rect.x + rect.width &&
        point.y >= rect.y &&
        point.y <= rect.y + rect.height);
}
export function rectCenter(rect) {
    return { x: rect.x + rect.width / 2, y: rect.y + rect.height / 2 };
}
/** Ray casting. Points exactly on an edge may fall either way, which is fine here. */
export function pointInPolygon(polygon, point) {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const a = polygon[i];
        const b = polygon[j];
        const straddlesY = a.y > point.y !== b.y > point.y;
        if (!straddlesY)
            continue;
        const crossingX = ((b.x - a.x) * (point.y - a.y)) / (b.y - a.y) + a.x;
        if (point.x < crossingX)
            inside = !inside;
    }
    return inside;
}
export function closestPointOnSegment(a, b, point) {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    const lengthSquared = dx * dx + dy * dy;
    if (lengthSquared === 0)
        return { x: a.x, y: a.y };
    const t = Math.max(0, Math.min(1, ((point.x - a.x) * dx + (point.y - a.y) * dy) / lengthSquared));
    return { x: a.x + t * dx, y: a.y + t * dy };
}
/**
 * Snap a point into a polygon: returns it unchanged if already inside, otherwise
 * the nearest point on the boundary. This is what makes a click just outside the
 * walkable area walk you to the edge instead of being ignored.
 */
export function clampToPolygon(polygon, point) {
    if (polygon.length < 3)
        return { x: point.x, y: point.y };
    if (pointInPolygon(polygon, point))
        return { x: point.x, y: point.y };
    let best = { x: point.x, y: point.y };
    let bestDistance = Number.POSITIVE_INFINITY;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const candidate = closestPointOnSegment(polygon[j], polygon[i], point);
        const distance = Math.hypot(candidate.x - point.x, candidate.y - point.y);
        if (distance < bestDistance) {
            bestDistance = distance;
            best = candidate;
        }
    }
    return best;
}
/**
 * La dirección de la arista más cercana a un punto, normalizada.
 *
 * Es lo que convierte un choque en un deslizamiento: proyectando el movimiento sobre
 * esta dirección, el avatar roza la pared y sigue avanzando en vez de frenar en seco.
 * Devuelve `null` sólo si el polígono es degenerado.
 *
 * Se mide contra el SEGMENTO y no contra los vértices: cerca del medio de una arista
 * larga, el vértice más próximo puede estar lejísimos y apuntar a otro lado.
 */
export function nearestEdgeDirection(polygon, point) {
    let best = null;
    let bestDistance = Number.POSITIVE_INFINITY;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const a = polygon[j];
        const b = polygon[i];
        const closest = closestPointOnSegment(a, b, point);
        const distance = Math.hypot(closest.x - point.x, closest.y - point.y);
        if (distance >= bestDistance)
            continue;
        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const length = Math.hypot(dx, dy);
        if (length === 0)
            continue;
        bestDistance = distance;
        best = { x: dx / length, y: dy / length };
    }
    return best;
}
export function polygonBounds(polygon) {
    const xs = polygon.map((p) => p.x);
    const ys = polygon.map((p) => p.y);
    const minX = Math.min(...xs);
    const minY = Math.min(...ys);
    return { x: minX, y: minY, width: Math.max(...xs) - minX, height: Math.max(...ys) - minY };
}
//# sourceMappingURL=geometry.js.map